/**
 * SearchBox - 통합 검색 컴포넌트
 * 모든 페이지에서 일관된 검색 UI 제공
 */

import React from 'react';
import { Search } from 'lucide-react';
import './SearchBox.css';

function SearchBox({
  value,
  onChange,
  placeholder = "검색...",
  disabled = false,
  autoFocus = false,
  className = ""
}) {
  return (
    <div className={`ui-search-box ${className}`}>
      <Search size={16} className="ui-search-icon" />
      <input
        type="text"
        className="ui-search-input"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        autoFocus={autoFocus}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck="false"
        data-lpignore="true"
        data-form-type="other"
        data-1p-ignore="true"
      />
    </div>
  );
}

export default SearchBox;
